import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { useI18n } from "@/i18n";

export function Footer() {
  const { t } = useI18n();
  return (
    <footer id="contacto" className="bg-[#050505] border-t border-white/10">
      <div className="w-full max-w-screen-2xl mx-auto px-4 md:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <img src="/esoesly-tile.png" alt="ESOESLY" className="w-10 h-10 rounded-md" />
              <span className="font-clash font-black text-3xl text-[#f5f5f5]">
                ESO<span className="text-[#ff4500]">ESLY</span>
              </span>
            </div>
            <p className="font-plex text-[#a3a3a3] mt-4 max-w-sm">{t.footer.desc}</p>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-widest text-[#555] mb-4">{t.footer.contact}</p>
            <ul className="space-y-4 font-plex text-sm text-[#a3a3a3]">
              <li>
                <a href="mailto:perezesoesly95@gmail.com" data-testid="contact-email" className="flex items-start gap-3 hover:text-[#ff4500] transition-colors">
                  <EnvelopeSimple size={18} className="text-[#ff4500] mt-0.5 shrink-0" />
                  perezesoesly95@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+17133764536" data-testid="contact-phone" className="flex items-start gap-3 hover:text-[#ff4500] transition-colors">
                  <Phone size={18} className="text-[#ff4500] mt-0.5 shrink-0" />
                  (713) 376-4536
                </a>
              </li>
              <li>
                <a
                  href="https://maps.google.com/?q=2401+FOUNTAIN+VIEW+DR+STE+464+HOUSTON+TX+77057"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-address"
                  className="flex items-start gap-3 hover:text-[#ff4500] transition-colors"
                >
                  <MapPin size={18} className="text-[#ff4500] mt-0.5 shrink-0" />
                  <span>2401 Fountain View Dr, Ste 464<br />Houston, TX 77057</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-widest text-[#555] mb-4">{t.footer.nav}</p>
            <ul className="space-y-3 font-plex text-sm text-[#a3a3a3]">
              <li><a href="#catalogo" className="hover:text-[#ff4500] transition-colors">{t.footer.links.catalogo}</a></li>
              <li><a href="#marcas" className="hover:text-[#ff4500] transition-colors">{t.footer.links.marcas}</a></li>
              <li><a href="#ventajas" className="hover:text-[#ff4500] transition-colors">{t.footer.links.ventajas}</a></li>
              <li><a href="#registro" className="hover:text-[#ff4500] transition-colors">{t.footer.links.registro}</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-widest text-[#555] mb-4">{t.footer.legal}</p>
            <ul className="space-y-3 font-plex text-sm text-[#a3a3a3]">
              <li><a href="#" className="hover:text-[#ff4500] transition-colors">{t.footer.links.terms}</a></li>
              <li><a href="#" className="hover:text-[#ff4500] transition-colors">{t.footer.links.shipping}</a></li>
              <li><Link to="/admin" className="hover:text-[#ff4500] transition-colors">{t.footer.links.admin}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 font-mono text-[11px] uppercase tracking-wider text-[#555]">
          <p>{t.footer.copy}</p>
          <p>{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
